var InFlight = InFlight || {};


InFlight.lbeSearch = (function() {

    var _getLbeData = function (searchOptions, callback) {
        var myconfig = {
            targetUrl: InFlight.NLX.Cfg.Customer.psBaseUrl() + '/q/?ICAction=ICQryNameURL=PUBLIC.FSP_LBE_14B_DIR&',
            targetVerb: 'GET',
            followProposedTemplate: false,
            manualRequestObj: [
                {
                    Lbl: 'csvContent',
                    Src: 'body',
                    Data: 'text'
                },
                {
                    Lbl: "error",
                    Src: "form[id='login']",
                    Data: "html"
                }
            ],
            callback: function (data) {
                if(data.CaptureResults.error && data.CaptureResults.error[0].Properties.html.includes("You must have cookies enabled")) {
                    return _getLbeData(searchOptions, callback); //need to hit the site initially to get right cookies. Just get the query again.
                } else if (data.CaptureResults.error) {
                    window.location.href = '/pages/error.aspx';
                }
                //papaparse is a lightweight csv parser
                var csv = Papa.parse(data.CaptureResults.csvContent[0].Properties.text);
                if(csv.errors.length) {
                    window.location.href = '/pages/error.aspx';
                } else {
                    csv.data.shift(); //remove headings
                    csv.data.pop(); //remove empty last entry
                    var simplifiedResults = csv.data.map(function(row) {
                        return {
                            entityName: row[0],
                            longName: row[1],
                            supBidId: row[2],
                            businessAddress: row[3],
                            businessAddress2: row[4],
                            city: row[5],
                            state: row[6],
                            postalCode: row[7],
                            mailAddress: row[8],
                            mailAddress2: row[9],
                            mailCity: row[10],
                            mailState: row[11],
                            mailPostal: row[12],
                            contactName: row[13],
                            phone: row[14],
                            emailId: row[15],
                            ownershipType: row[16],
                            certType: row[17],
                            entityType: row[18],
                            certifiedFor: row[19],
                            createdDate: row[21],
                            supervisorDistrict: row[22],
                            lbeRestrictions: row[23],
                            equalBenefitsCompliance: row[24]
                        }
                    });
                    var filteredResults = simplifiedResults.filter(function(result) {
                        return filterResult(result, searchOptions);
                    });
                    if(callback) {
                        callback(filteredResults);
                    } else {
                        return filteredResults;
                    }
                }
            }
        }
        var InFlightDC = new InFlightDCType(false);
        InFlightDC.init(myconfig);
    }

    function filterResult(result, searchOptions) {

        //cert size applies to specific categorys of businesses. If none are selected search entire category field.
        function searchByCertSize(result, searchOptions) {
            if(searchOptions.categories.length === 0) {
                return searchOptions.certSize.some(function (size) {
                    return result.certifiedFor.indexOf(size) >= 0;
                });
            } else {
                var parsedCertifiedForArr = result.certifiedFor.split('|');
                //only filter businesses with any of the selected categories
                parsedCertifiedForArr = parsedCertifiedForArr.filter(function(cert) {
                    return searchOptions.categories.some(function(cat) {
                        return cert.indexOf(cat) >= 0;
                    })
                })

                //show business only if category has selected cert sizes
                return searchOptions.certSize.some(function(size) {
                    return parsedCertifiedForArr.find(function(cert) {
                        return cert.indexOf(size) >= 0; 
                    })
                })
            }
        }

        function searchByCategories(result, searchOptions) {
            if(searchOptions.categories.length === 0) {
                return true;
            }
            //special case with cert size = OVER
            return searchOptions.categories.some(function (type) {
                var categoryCodePos = result.certifiedFor.indexOf(type);
                if(categoryCodePos >=0 ) {
                    //don't filter if result includes (OVER). It still might pass if others certification codes apply - then we filter (OVER) out on front end
                    if(result.certifiedFor.split(type + ' - ')[1].substring(0,6) === "(OVER)") { 
                        return false;
                    }
                    return true
                }

                return false
            });
        }
        function searchGeneral(result, searchOptions) {
            if(searchOptions.general.trim() === "") return true;
            for(var property in result) {
                if(result[property] && result[property].toUpperCase().indexOf(searchOptions.general.toUpperCase()) >= 0) {
                    return true;
                }
            }
            return false;
        }
        function searchByCertType(result, searchOptions) {
            if(searchOptions.certType.length === 0){
                return true;
            }
            if(searchOptions.certType.indexOf("LBE") > -1) {
                if(result.certType.trim() === "LBE" || result.certType.trim() === "NLBE") {
                    return true;
                }
            }
            if(searchOptions.certType.indexOf("PLBE") > -1) {
                return result.certType.trim() === "PLBE";
            }
            return false;
        }
        function searchBySupervisorDistrict(result, searchOptions) {
            if(searchOptions.supDistrict.length === 0) {
                return true;
            }
            return searchOptions.supDistrict.some(function (district) {
                return result.supervisorDistrict === district.trim();
            });
        }

        if(!searchOptions){
            return result;
        } 
        else {
            var certTypeFilter = searchByCertType(result, searchOptions);
            var ownershipTypeFilter = searchOptions.ownershipType.length === 0 || searchOptions.ownershipType.includes(result.ownershipType);
            var zipFilter = searchOptions.zip.trim() === "" || result.postalCode.trim().includes(searchOptions.zip.trim()) || result.mailPostal.trim().includes(searchOptions.zip.trim()); 
            var certSizeFilter = searchOptions.certSize.length === 0 || searchByCertSize(result, searchOptions);
            var categoriesFilter = searchByCategories(result, searchOptions);
            var generalFilter = searchGeneral(result, searchOptions);
            var supDistrictFilter = searchBySupervisorDistrict(result, searchOptions);
            return certTypeFilter && ownershipTypeFilter && zipFilter && certSizeFilter && categoriesFilter && generalFilter && supDistrictFilter;
        }
    }

    var categories = [
        "ASBESTOS ABATEMENT CONTRACTOR (C-22) | CN068",
        "BACKHOE SERVICE | CN018",
        "BOILER/HOT WATER/STEAM FITTING CONTRACTOR (C-4) | CN043",
        "BUILDING MOVING WRECKING CONTRACTORS (C21) | CN030",
        "C-61 SPECIALTY CONTRACTOR | CN073",
        "CARPENTRY, CABINETS & MILLWORK (C6) | CN010",
        "CONCRETE CONTRACTOR (C-8) | CN046",
        "CONCRETE/RELATED SERVICES (D6) | CN038",
        "CONSTRUCTION CLEAN-UP (D-63) | CN050",
        "CONSTRUCTION TRAFFIC CONTROL SERVICES (C-31) | CN045",
        "DOORS, GATES AND ACTIVATING DEVICES CONTRACTOR (D28) | CN049",
        "DRILLING SERVICES(D9)(D30) | CN044",
        "DRYWALL CONTRACTOR (C-9) | CN008",
        "EARTHWORK & PAVING(C-12) | CN033",
        "ELECTRICAL CONTRACTING(C10) | CN034",
        "ELECTRICAL SIGN CONTRACTOR (C-45) | CN012",
        "ELEVATOR INSTALLATION & REPAIR(C11) | CN039",
        "FENCING CONTRACTOR (C-13) | CN016",
        "FIRE PROTECTION CONTRACTOR(C16) | CN040",
        "FLOOR COVERING CONTRACTORS (C-15) | CN041",
        "FRAMING AND ROUGH CARPENTRY CONTRACTOR (C-5) | CN058",
        "GENERAL BUILDING CONTRACTING (B) | CN031",
        "GENERAL ENGINEERING CONTRACTING(A) | CN032",
        "GLAZING CONTRACTOR (C-17) | CN042",
        "HAZARDOUS MATERIAL TRUCKING | CN066",
        "HAZARDOUS SUBSTANCE REMOVAL CERTIFICATION | CN027",
        "HEATING, VENTILATION, AIR CONDITIONING CONTRACTOR (C-20) | CN029",
        "HVAC FILTER & DUCT CLEANING | CN063",
        "HYDROSEED SPRAYING (D-59) | CN069",
        "INSULATION/ACOUSTICAL CONTRACTOR (C-2) | CN009",
        "LANDSCAPE CONTRACTOR (C-27) | CN028",
        "LATHING AND PLASTERING CONTRACTOR (C-35) | CN007",
        "LOCK AND SECURITY EQUIPMENT (C28) | CN071",
        "LOW VOLTAGE SYSTEMS CONTRACTOR (C-7) | CN060",
        "MACHINERY  AND PUMPS (D-21) | CN072",
        "MASONRY CONTRACTOR (C-29) | CN011",
        "METAL PRODUCTS CONTRACTOR (D24) | CN052",
        "NON-SPECIALIZED (D-64) | CN070",
        "ORNAMENTAL METALS CONTRACTOR (C-23) | CN013",
        "PAINTING AND DECORATING CONTRACTOR (C-33) | CN036",
        "PARKING & HIGHWAY IMPROVEMENT(C-32) | CN017",
        "PIPELINE CONTRACTOR (C-34) | CN015",
        "PLUMBING(C36) | CN035",
        "PREFABRICATED EQUIPMENT CONTRACTOR (D34) | CN053",
        "REFRIGERATION CONTRACTOR (C-38) | CN055",
        "REINFORCING STEEL CONTRACTORS (C-50) | CN004",
        "ROOFING CONTRACTOR (C-39) | CN037",
        "SAND AND WATER BLASTING (D38) | CN051",
        "SANDBLASTING CONTRACTOR (D-38) | CN025",
        "SANITATION SYSTEMS CONTRACTOR (C-42) | CN019",
        "SCAFFOLDING CONTRACTOR (D-39) | CN054",
        "SHEET METAL CONTRACTORS (C-43) | CN001",
        "SIGN RENOVATION AND  INSTALLATION | CN059",
        "SOLAR CONTRACTORS (C-46) | CN020",
        "STREET SWEEPER | CN006",
        "STORM WATER PPP (D-64) | CN056",
        "STRUCTURAL STEEL CONTRACTORS (C-51) | CN003",
        "SWIMMING POOL CONTRACTORS (C-53) | CN021",
        "TILE INSTALLATION CONTRACTOR (C-54) | CN014",
        "TREE SERVICE (D49) | CN047",
        "WATER TRUCKS-DUST CONTROL | CN067",
        "WATERPROOFING AND WEATHERPROOFING (D51) | CN057",
        "WELDING CONTRACTOR (C-60) | CN002",
        "WELL DRILLING CONTRACTOR (C-57) | CN022",
        "WINDOW COVERINGS (D-52) | CN061",
        "TRUCKING AND HAULING | CN005",
        "AGRI/HORTICULTURAL EQUIPMENT PARTS AND SUPPLIES | EQ079",
        "AGRICULTURAL & GARDENING TOOLS | EQ066",
        "AIRPLANES/HELICOPTERS + COMPONENTS | EQ044",
        "AIRPORT EQUIPMENT, PARTS, SUPPLIES | EQ026",
        "ANIMAL FEED, SUPPLIES & EQUIPMENT | EQ007",
        "ANIMALS/BIRDS/FISH | EQ113",
        "ARTS, CRAFTS, AND SUPPLIES | EQ014",
        "AUDIO & VISUAL EQUIPMENT SALES & SUPPLIES | EQ056",
        "AUTOMOTIVE PARTS & SUPPLIES | EQ093",
        "BAR CODE PRINTERS | EQ072",
        "BATTERIES, RECHARGABLE & CHARGERS, INCLUDING DRY CELL, WET CELL AND AUTOMOTIVE | EQ131",
        "BICYCLES, PARTS & ACCESSORIES INCLUDING BIKE RACKS | EQ058",
        "BOILER/HOT WATER/STEAM FITTING EQUIP&SUPPLIES | EQ091",
        "BOOKS/NEWSPAPERS/MAGAZINES/MAPS | EQ107",
        "BUILDINGS, PORTABLE OR PREFABRICATED | EQ041",
        "CABINETS & COUNTERS EQUIPMENT & SUPPLIES | EQ051",
        "CAR WASH EQUIPMENT, PARTS & SUPPLIES | EQ073",
        "CARS, VANS, SMALL TRUCKS | EQ106",
        "CHEMICALS & GASES | EQ002",
        "CLOCK/WATCH/TIMER/JEWELRY EQUIP & SUPPLIES | EQ063",
        "CLOTHING, BEDDING, LINEN AND UNIFORMS | EQ115",
        "COMMUNICATIONS EQUIPMENT & SUPPLIES | EQ094",
        "COMPUTER HARDWARE/SOFTWARE/PERIPH EQUIP. | EQ108",
        "CONCRETE SUPPLIER AND MANUFACTURER | EQ031",
        "CONSTRUCTION & BUILDING MATERIALS AND SUPPLIES | EQ092",
        "CONSTRUCTION EQUIPMENT, SALES & RENTAL | EQ130",
        "CONTROLS, INDUSTRIAL & COMMERCIAL | EQ036",
        "CORROSION PREVENTION PRODUCTS | EQ076",
        "CRIMINAL JUSTICE: PRISON/INMATE SUPPLIES | EQ065",
        "DAY CARE EQUIPMENT AND TOYS | EQ120",
        "DISTANCE VIEWING EQUP.& SUPPLIES | EQ054",
        "DOORS & DOOR PARTS | EQ049",
        "EDUCATIONAL & TRAINING MATERIALS | EQ016",
        "ELECTRICAL EQUIPMENT AND SUPPLIES | EQ081",
        "ELEVATOR & ESCALATOR PARTS, MTLS & SUPPL | EQ118",
        "EMBOSSING & ENGRAVING EQUIPMNT & SUPLIES | EQ035",
        "EMERGENCY  PREPARDNESS SUPPLIES | EQ075",
        "EMERGENCY VEHICLES SALES, EQUIP, & SUPPLIES | EQ017",
        "ENERGY COLLECTING EQUIPMENT & SUPPLIES | EQ018",
        "ENVIRONMENTAL SAFETY TESTING EQUIPMENT | EQ042",
        "EXHIBITION & CONVENTION  EQUP & SUPPLIES | EQ124",
        "FABRICS, CLOTH, TEXTILES | EQ004",
        "FARE COLLECTION DEVICES | EQ008",
        "FENCING MATERIALS AND SUPPLIES | EQ048",
        "FIRE FIGHTING/RESCUE EQUIP & SUPPLIES | EQ100",
        "FLAGS AND BANNERS EQUIPMENT AND SUPPLIES | EQ046",
        "FLOOR COVERING MATERIALS AND SUPPLIES | EQ019",
        "FOOD PREPARATION/RESTAURANT EQUIPMENT | EQ110",
        "FOUNDRY CASTINGS | EQ013",
        "FUNERAL/INTERMENT EQUIPMENT SUPPLIES | EQ122",
        "FURNITURE: SALES, EQUIP AND SUPPLIES | EQ037",
        "GAS STATION, PETROLEUM EQUIP & SUPPLIES | EQ032",
        "GLASS, MIRRORS & WINDOWS | EQ050",
        "GOLF COURSE MAINTENANCE EQUIP & SUPPLIES | EQ062",
        "HOUSEHOLD APPLIANCES SALES & SUPPLIES | EQ005",
        "HOUSEWARES/MINOR FURNISHINGS | EQ103",
        "HVAC AND HEATING EQUIPMENT AND SUPPLIES | EQ022",
        "INSTRUMENTATION EQUIPMENT & SUPPLIES | EQ083",
        "JANITORIAL EQUIPMENT & SUPPLIES | EQ080",
        "LABORATORY EQUIPMENT & SUPPLIES | EQ096",
        "LAUNDRY & DRY CLEANING EQUIP & SUPPLIES | EQ021",
        "LAW ENFORCEMENT EQUIPMENT & SUPPLIES | EQ082",
        "LIBRARY EQUIPMENT & SUPPLIES | EQ023",
        "LIFTING EQUIPMENT & SUPPLIES | EQ027",
        "LIGHTING SUPPLIES | EQ088",
        "LOCKS, PADLOCKS, LOCKSMITH SUPPLIES | EQ127",
        "LOGGING EQUIPMENT & SUPPLIES | EQ114",
        "LUMBER EQ & SUPPLIES | EQ089",
        "MARINE EQUIPMENT & SUPPLIES | EQ105",
        "MEDICAL/HOSPITAL/DENTAL EQP, PARTS & SUP | EQ109",
        "METALS FOR CUSTOM FABRICATION EQUIP. &SUPPLIES | EQ033",
        "MICROFILM EQUIPMENT & SUPPLIES | EQ012",
        "MONEY HANDLING EQUIPMENT & SUPPLIES | EQ040",
        "MOTOR BICYCLES/PARTS/SUPPLIES/GEAR | EQ067",
        "MUSICAL INSTRUMENTS, EQUIP & SUPPLIES | EQ045",
        "OFFICE EQUIPMENT | EQ112",
        "OFFICE RENTAL, INCLUDING MOBILE OFFICES | EQ034",
        "OFFICE SUPPLIES | EQ104",
        "PACKING MATERIALS | EQ009",
        "PAINTING/WALLCOVERING EQUIPT & SUPPLIES | EQ090",
        "PAPER PRODUCTS | EQ116",
        "PARTY & HOLIDAY SUPPLIES | EQ043",
        "PEST CONTROL EQUIPMENT & SUPPLIES | EQ024",
        "PHARMACEUTICAL SUPPLIES | EQ097",
        "PHOTOGRAPHY EQUIPMENT  & SUPPLIES | EQ011",
        "PICTURE FRAMING SUPPLIES | EQ125",
        "PIPES, VALVES AND FITTING SUPPLIES | EQ129",
        "PLANTS, FOLIAGE, TREES, LANDSCAPE SUPPLIES | EQ132",
        "PLASTICS & PLASTIC PRODUCTS | EQ001",
        "PLAYGROUND/PARK EQUIPMENT & SUPPLIES | EQ064",
        "POSTERS | EQ060",
        "PRINTING/GRAPHIC EQUIPMENT & SUPPLIES | EQ025",
        "PROMOTIONAL AND GIFT ITEMS | EQ084",
        "RADIOACTIVE MATERIALS | EQ098",
        "RECREATION/ATHLETIC EQUIPMENT & SUPPLIES | EQ111",
        "REFRIGERATION EQUPT, PARTS & SUPPLIES | EQ117",
        "RUBBER & RUBBER PRODUCTS | EQ010",
        "SAFES & SAFETY DEPOSIT BOXES | EQ059",
        "SAFETY & PERSONAL PROTECTION ITEMS | EQ101",
        "SANDBLASTING EQUIPMENT AND SUPPLIES | EQ123",
        "SATELLITE EQUIPMENT, PARTS & SUPPLIES | EQ126",
        "SCALES & WEIGHING APPARATUS | EQ028",
        "SECURITY & FIRE ALARM SYSTEMS EQUIP. & SUPPLIES | EQ119",
        "SEWING EQUIPMENT & SUPPLIES | EQ029",
        "SIGN MAKING SUPPLIES | EQ128",
        "STEEL & STEEL PRODUCTS | EQ003",
        "STORAGE SYSTEMS LAY-OUT AND INSTALLATION | EQ053",
        "STORAGE/SHELVING PRODUCTS | EQ055",
        "SURVEY/ENGINEER/DRAFTING EQUP & SUPPLIES | EQ030",
        "SWIMMING POOL EQUIPMENT & SUPPLIES | EQ061",
        "TELECOMMUNICATIONS PRODUCTS | EQ074",
        "TENT RENTAL | EQ052",
        "THEATRICAL EQUIPT, LIGHTS/SPEAKERS ETC | EQ039",
        "TICKETS | EQ070",
        "TOILETRIES/HAIR/BEAUTY SUPPLIES | EQ006",
        "TOILETS/SHOWERS, PORTABLE & SCEPTIC | EQ020",
        "TOW TRUCKS, PARTS & SUPPLIES | EQ068",
        "TRAFFIC SAFETY & TRAFFIC CONTROL DEVICES | EQ077",
        "TRANSPORT EQUIP AND SUPPLIES | EQ071",
        "TRUCKS/TRAILERS & PARTS | EQ078",
        "UTILITY PRODUCTS (WATER METERS ETC) | EQ069",
        "UTILITY VEHICLES & PARTS | EQ121",
        "VETERINARY EQUIPMENT & SUPPLIES | EQ099",
        "VOTING EQUIPMENT & SUPPLIES | EQ057",
        "WATER & SEWAGE TREATMENT SUPPLIES | EQ102",
        "WATERWAYS & PORT SAFETY SYSTEMS | EQ047",
        "WELDING EQUIPMENT & SUPPLIES | EQ038",
        "WINDOW COVERINGS | EQ015",
        "ADVERTISING | GS007",
        "ADVERTISING AGENCIES | GS130",
        "ADVERTISING DISPLAYS: POINT OF SALE | GS018",
        "AGRICULTURAL/HORTIC EQU MAINT & REPAIR | GS065",
        "AIRPLANES/HELICOPTERS MAINT & REPAIR | GS070",
        "AIRPORT SERVICES: SKYCAPS | GS043",
        "ANIMAL CARE SERVICES (NON-MEDICAL) | GS099",
        "ANSWERING SERVICE & MESSAGE CENTERS | GS019",
        "APPLIANCE REPAIR | GS041",
        "ARMORED TRANSPORT SERVICES | GS120",
        "ART RESTORATION AND CONSERVATION | GS087",
        "AUDIO & VISUAL EQUIP. MAINTENANCE & REPAIR | GS072",
        "AUTO & OTHER VEHICLE SALES, RENTAL, LEASES | GS097",
        "AUTO SHOP EQUIP, SALES, MAINT. & REPAIR | GS112",
        "AUTOMOTIVE MAINTENANCE & REPAIR | GS094",
        "BICYCLE MAINTENANCE & REPAIR | GS074",
        "BILLING SERVICES | GS024",
        "BOOKS, PUBLISHERS | GS133",
        "CANVAS SALES, SEWING & REPAIRS, AWNINGS | GS073",
        "CAR WASH SERVICE, EQUIPMENT MAINT & REPAIR | GS081",
        "CAREGIVERS/SOCIAL SERVICES | GS088",
        "CATERING & RESTAURANT SERVICES | GS083",
        "CLIPPING SERVICES: NEWSPAPER/RADIO/TV | GS025",
        "CLOCK/WATCH/TIMER/JEWELRY MAINT & REPAIR | GS051",
        "COMMUNICATIONS EQP, INSTALL/MAINT/REPAIR | GS045",
        "COMPUTER AIDED DESIGN (CAD) | GS124",
        "COMPUTER GRAPHICS AND GRAPHIC ARTS | GS102",
        "COMPUTER SYSTEMS EQUIP.MAINT. & REPAIR | GS093",
        "COMPUTER SYSTEMS SERVICES | GS109",
        "COMPUTER TRAINING | GS131",
        "COMPUTER:  WEB DESIGN AND MAINT. | GS129",
        "COMPUTER: INTERNET SERVICE PROVIDER | GS125",
        "CONCRETE DELIVERY AND/OR PUMPING | GS138",
        "CONSTRUCTION EQUIPMENT, MAINT & REPAIR | GS116",
        "COURT REPORTER TRANSCRIPTION SERVICES | GS103",
        "CREDIT CHECK SERVICE | GS020",
        "CRIMINAL JUSTICE: CRIME/GANG PREVENTION | GS023",
        "CRIMINAL JUSTICE: PRISON/INMATE SERVICES | GS077",
        "DATA INFORMATION NETWORK SERVICES | GS027",
        "DATABASE  DEVELOPMENT & ANALYSIS | GS132",
        "DEBT COLLECTION SERVICES | GS011",
        "ELECTRICAL EQUIPMENT MAINT & REPAIR | GS057",
        "EMBOSSING & ENGRAVING EQUIP MAINT & RPR | GS080",
        "EMERGENCY PREPAREDNESS SERVICES | GS067",
        "EMERGENCY VEHICLES MAINT AND REPAIR | GS076",
        "EMPLOYMENT AGENCIES: EXECUTIVE SEARCH | GS128",
        "EMPLOYMENT AGENCIES: TEMPORARY HELP | GS086",
        "EMPLOYMENT DEVELOPMENT PROGRAMS | GS022",
        "EQUIPMNT (INDUSTRIAL), CERTIFIED VEHICLE TESTING | GS036",
        "EVENT PLANNING AND RELATED SERVICES | GS134",
        "EXHIBIT & EVENT DESIGN & CONSTRUCTION | GS033",
        "EXHIBITION & CONVENTION PLANNERS | GS135",
        "FIRE FIGHTING/RESCUE EQUIP MAINT & RPR | GS049",
        "FITNESS CENTERS | GS015",
        "FLORISTS: FLOWERS AND ARRANGEMENTS | GS110",
        "FOOD PREPARATION EQUIPMNT MAINT & REPAIR | GS056",
        "FUNERAL SERVICES/INTERMENT | GS009",
        "FURNITURE: MAINTENANCE AND REPAIR | GS060",
        "HAIR STYLISTS, BARBERS & BEAUTICIANS | GS017",
        "HOMEMAKING SERVICES | GS084",
        "HOTELS/RESIDENCES FOR THE SICK/HOMELESS | GS107",
        "INDUSTRIAL EQUIP. MAINT. & REPAIR | GS096",
        "INSTRUMENTATION EQUIPMENT MAINT & REPAIR | GS066",
        "INSURANCE SERVICES | GS127",
        "INTERMODAL CONTAINER EQUIPMENT REPAIR | GS079",
        "JANITORIAL EQUIPMENT, MAINT & REPAIR | GS114",
        "JANITORIAL SERVICES: BUILDING,CONSTRUCTION,POWER WASHING, GRAFFITI REMOVING. | GS090",
        "LABORATORY EQUIPMENT MAINT & REPAIR | GS061",
        "LAUNDRY & DRY CLEANING EQUIP MAINT & RPR | GS062",
        "LAUNDRY & DRY CLEANING SERVICES | GS100",
        "LEGAL PROCESS SERVING | GS014",
        "LOCKSMITHS SERVICES | GS029",
        "MAILING LIST/DIRECTORY DEVELOP & SALES | GS050",
        "MAILING SERVICES | GS105",
        "MARINE RELATED SERVICES | GS016",
        "MATERIAL HANDL/LIFTING EQUIP MAINT & RPR | GS069",
        "MEDICAL TRANSCRIPTION SERVICES | GS030",
        "MEDICAL/HOSPITAL/DENTAL EQUIP MAINT & RP | GS034",
        "MESSENGER & DELIVERY SERVICES | GS002",
        "METALS HEAT TREATING | GS035",
        "MICROFILM EQUIPMENT MAINTENANCE & REPAIR | GS038",
        "MICROFILMING | GS008",
        "MODEL MAKERS, ARCHITECTURAL | GS032",
        "MONEY COLLECTION & COUNTING | GS058",
        "MONEY HANDLING EQUIPMENT, MAINT & REPAIR | GS115",
        "MOTOR BICYCLE REPAIR | GS121",
        "MOVING & STORAGE | GS101",
        "MUSICAL INSTRUMENTS MAINTENANCE & REPAIR | GS052",
        "NEIGHBORHOOD SERVICES: BEAUTIFICATION/CLEAN UP | GS042",
        "NEWSPAPER & MAGAZINE PUBLISHING | GS123",
        "NEWSPAPER/MAGAZINE SUBSCRIPTIONS | GS106",
        "OFFICE EQUIPMENT MAINTENANCE & REPAIR | GS095",
        "PEST CONTROL SERVICES | GS091",
        "PHOTO LABORATORIES | GS013",
        "PHOTOGRAPHY EQUIPMENT MAINT & REPAIR | GS064",
        "PICTURE FRAMING | GS037",
        "PRINTING & TYPOGRAPHY | GS104",
        "PRINTING/GRAPHIC EQUIPMNT MAINT & REPAIR | GS046",
        "PRIVATE INVESTIGATORS | GS001",
        "RADIO TRANSMITTER SERVICE | GS040",
        "REAL ESTATE: DEVELOPERS | GS122",
        "RECORDS MANAGEMENT & STORAGE | GS028",
        "RECREATION/ATHLETIC EQUIP MAINT & RPR | GS047",
        "RECREATIONAL ACTIVITIES | GS021",
        "RECYCLING SERVICES | GS031",
        "REFRIGERATION EQUIP, MAINT & REPAIR | GS111",
        "REPRODUCTION SERVICES | GS012",
        "SCALES & WEIGHING EQUP MAINT & REPAIR | GS075",
        "SCAVENGER SERVICES | GS089",
        "SCREENPRINTING, EMBROIDERY AND EMBOSSING SERVICES | GS141",
        "SECURITY GUARD SERVICES | GS092",
        "SECURITY/ FIRE ALARM SYSTEMS MAINT & RPR | GS068",
        "SEWING EQUIPMENT MAINT & REPAIR | GS063",
        "SIGNS, DIRECTIONAL & INFORMATIONAL | GS010",
        "SPACE PLANNING AND RELOCATION SERVICES | GS136",
        "STEAM CLEANING/PRESSURE WASHING | GS140",
        "SURVEY/ENG/DRAFTING EQUIP MAINT & REPAIR | GS059",
        "TELECOMMUNICATIONS SERVICES | GS126",
        "TELEPHONE SERVICES | GS108",
        "THEATRICAL EQUIPMENT MAINT & REPAIR | GS053",
        "THEATRICAL PRODUCTION SERVICES | GS003",
        "TICKET SALES SVCS, THEATRE, SPORTS ETC | GS048",
        "TOURIST SUPPORT SERVICES | GS044",
        "TOWING | GS006",
        "TRANSPORTATION SERVICES | GS005",
        "TRANSPORTATION VEHICLES MAINT & REPAIR | GS118",
        "TRAVEL AGENCIES/TRAVEL RELATED SERVICES | GS085",
        "TRUCK/UTILITY VEHICLE MAINT & REPAIR | GS117",
        "UPHOLSTERY | GS026",
        "UTILITIES & POWER SERVICES | GS098",
        "UTILITY VEHICLE MAINT & REPAIR | GS119",
        "VENDING MACHINES | GS142",
        "VIDEO/TELEVISION PRODUCTION SERVICES | GS137",
        "VOICE MAIL SYSTEMS INSTALLATION | GS078",
        "WATER & SEWAGE TREATMENT EQP MAINT & RPR | GS071",
        "WELDING EQUIPMENT MAINTENANCE & REPAIR | GS082",
        "WINDOW COVERING SERVICES & REPAIR | GS055",
        "ACCOUNTING SERVICES: BOOKKEEPING | PS036",
        "ACCOUNTING SERVICES: CPAs | PS039",
        "ACOUSTICAL ENGINEERING/NOISE ANALYSIS | AE009",
        "ACOUSTICAL/AUDIO/VISUAL  ANALYSIS SERVICES | PS059",
        "ADMINISTRATIVE SERVICES | PS019",
        "AGRICULTURAL SERVICES | PS037",
        "ARCHEOLOGY & CULTURAL RESOURCES | PS004",
        "ARCHITECTURAL ILLUSTRATOR | PS027",
        "ARCHITECTURAL, INCLUDING HISTORICAL AND CONSERVATOR SERVICES | AE019",
        "ART SERVICES | PS030",
        "ART SHOWS: DESIGN & INSTALLATION | PS038",
        "ARTISTS | PS032",
        "AVIATION PLANNING & RESEARCH | PS051",
        "CARTOGRAPHY | PS053",
        "CIVIL ENGINEERING | AE003",
        "COMMUNITY RELATIONS/PUBLIC AFFAIRS | PS002",
        "CONSTRUCTION MANAGEMENT | PS058",
        "CORROSION ENGINEERING | AE010",
        "COURT REPORTERS | PS005",
        "CRIMINAL JUSTICE ADVISORY SERVICES | PS043",
        "CRISIS MANAGEMENT SERVICES | PS050",
        "DIVISION OF THE STATE ARCHITECT INSPECTOR OF RECORD | PS067",
        "ECONOMIC DEVELOPMENT SERVICES | PS063",
        "EDUCATIONAL AND TRAINING SERVICES | PS048",
        "EEO/MBE/WBE/OBE ASSISTANCE | PS008",
        "ELECTION PLANNING SERVICES | PS026",
        "ELECTRICAL ENGINEERING | AE006",
        "ELEVATOR ENGINEERS | AE016",
        "ENERGY EFFICIENCY SERVICES | PS028",
        "ENVIRONMENTAL ADVISORY SERVICES | PS010",
        "ENVIRONMENTAL IMPACT REPORTS | PS060",
        "ERGONOMICS ASSESSMENT AND TRAINING | PS061",
        "ETHICS SERVICES | PS057",
        "EXAMINATION/TESTING SERVICES | PS023",
        "FACILITATORS, MEETINGS/RETREATS | PS031",
        "FINANCIAL SERVICES | PS041",
        "FIRE PROTECTION ENGINEER | AE022",
        "FUND-RAISING SERVICES | PS054",
        "GEOTECHNICAL ENGINEERING | AE005",
        "HABITAT ENVIRONMENTAL SERVICES | PS044",
        "HAZARDOUS WASTE AND REMEDIATION SERVICES | PS045",
        "HEALTH & SAFETY TESTING SERVICES (OSHA) | PS022",
        "HEALTH CARE INFORMATION SERVICES | PS046",
        "HEALTH CLAIMS INSURANCE PROCESSING | PS020",
        "INTERIOR DESIGN | AE001",
        "INTERPRETERS | PS029",
        "LABORATORY SERVICES (MATERIALS TESTING) | PS047",
        "LANDSCAPE ARCHITECTURE | AE002",
        "LEGAL - ALTERNATIVE DISPUTE RESOLUTION | PS017",
        "LEGAL SERVICES: ATTORNEYS | PS016",
        "LIBRARY & BOOK SERVICES | PS013",
        "LIGHTING DESIGN | AE008",
        "LOBBYISTS & RELATED LEGISLATIVE SERVICES | PS035",
        "MARINE ARCHITECTURE & ENGINEERING | AE013",
        "MARKET RESEARCH | PS052",
        "MARKETING SERVICES | PS042",
        "MECHANICAL ENGINEERING | AE012",
        "MEDICAL SERVICES: MISCELLANEOUS | PS011",
        "MEDICAL: DENTISTS AND PHYSICIANS | PS012",
        "MUSEUM/ZOO/PARKS SERVICES | PS025",
        "OSHPD CLASS A INSPECTOR OF RECORD | PS068",
        "PARKING GARAGE FACILITY MAINTENANCE AND CLEANING | PS065",
        "PARKING GARAGE MANAGEMENT | PS064",
        "PHOTOGRAPHY SERVICES | PS001",
        "POLITICAL CAMPAIGN SERVICES | PS056",
        "PSYCHOLOGICAL TESTING/POLYGRAPHS | PS014",
        "PSYCHOLOGICAL/PSYCHIATRIC SUPPORT GROUPS | PS021",
        "PUBLIC RELATIONS SERVICES | PS033",
        "REAL ESTATE: APPRAISERS, BROKERS, AGENTS | PS034",
        "REAL ESTATE: PROPERTY MANAGEMENT | PS040",
        "RECORDS/INFORMATION MANAGEMENT SERVICES | PS015",
        "REGULATORY COMPLIANCE ASSISTANCE | PS018",
        "SECURITY/COMMODITY EXCHANGES | PS062",
        "SOCIO/ECONOMIC/STATISTICAL STUDIES | PS003",
        "SOLID WASTE MANAGEMENT SERVICES | PS055",
        "STRUCTURAL ENGINEERING | AE004",
        "SURVEYING (LAND & AERIAL) | AE015",
        "TECHNICAL & MISC. WRITING/EDITING SERVICES | PS007",
        "TRANSLATING SERVICES | PS006",
        "TRANSPORTATION & TRAFFIC ENGINEERING | AE011",
        "URBAN & REGIONAL PLANNING | PS009",
        "VALUE/QUALITY ENGINEERING | AE014",
        "VETERINARIANS & RELATED SERVICES | PS049",
        "WATER RESOURCES ENGINEERING | AE020",
        "WELLNESS SERVICES | PS069",
    ];

    var _getCategories = function() {
        return categories;
    }

    return {
        getCategories: _getCategories,
        getLbeData: _getLbeData
    };
})();